import orderCenterApi from '@/request/orderCenter';

// 获取订单详情
const getCourseOrderDetail = async({ commit, state }, insOrderId) => {
  const params = {
    insOrderId: insOrderId || '684470511484289024'
  };
  // 订单详情
  const orderDetail = await orderCenterApi.getCourseOrderDetail(params);
  if (orderDetail.status === 200) {
    console.log('orderDetail-->', orderDetail);
    commit('setOrderDetail', JSON.parse(JSON.stringify(orderDetail.message)));
    const params = {
      productId: orderDetail.message.courseId,
      studentId: orderDetail.message.studentId
    };
    countByProductIdStudentId({ commit, state }, params);
    listSignAndTallyByOrderId({ commit, state }, params);
  }
};
// 获取商品id是否有考勤
const countByProductIdStudentId = async({ commit, state }, data) => {
  const params = {
    productId: data.productId,
    studentId: data.studentId
  };
  const resp = await orderCenterApi.countByProductIdStudentId(params);
  if (resp.status === 200) {
    console.log('countByProductIdStudentId-->', resp);
    commit('setAttendanceTimes', JSON.parse(JSON.stringify(resp.message)));
  }
};
// 签到记录和结算单
const listSignAndTallyByOrderId = async({ commit, state }, orderId) => {
  const params = {
    orderId: orderId
  };
  try {
    const resp = await orderCenterApi.listSignAndTallyByOrderId(params);
    if (resp.status === 200) {
      console.log('listSignAndTallyByOrderId-->', resp);
      commit('setListSignAndTally', JSON.parse(JSON.stringify(resp.message)));
    }
  } catch (err) {
    console.log('签到记录和结算单err-->', err);
  }
};
// 这个返回签到记录和结算单

export default {
  getCourseOrderDetail,
  countByProductIdStudentId,
  listSignAndTallyByOrderId
};
